import * as React from 'react';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { FMIcon } from 'atoms';

export default (props: CheckboxProps) => (
    <Checkbox
        checkedIcon={<FMIcon type="checked" color="primary" />}
        icon={<FMIcon type="unchecked" color="primary" />}
        {...props}
    />
);
